export function assertTruthy<T extends any = any>(target: T, customErrorMessage?: string): asserts target is NonNullable<T> {
  if (!target) throw Error(customErrorMessage ?? 'Failed to assert truthiness.');
};